'use client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { IconExternalLink, IconEye, IconCopy } from '@tabler/icons-react';
import { ProjectRecord } from '@/lib/projects/project-types';
import { toast } from 'sonner';
import { ProjectLinkDialog } from '@/components/projects/ProjectLinkDialog';

interface RowActionsProps {
  project: ProjectRecord;
  onOpen: (project: ProjectRecord) => void;
}

export function RowActions({ project, onOpen }: RowActionsProps) {
  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpen(project);
  };

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(project.projectLink);
      toast.success('Link copied');
    } catch {
      toast.error('Failed to copy link');
    }
  };

  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex items-center gap-0.5">
        

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-7 w-7"
              asChild
            >
              <a
                href={project.projectLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open in new tab"
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              >
                <IconExternalLink className="h-4 w-4" />
              </a>
            </Button>
          </TooltipTrigger>
          <TooltipContent>Open in new tab</TooltipContent>
        </Tooltip>

       

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-7 w-7"
              onClick={handleCopy}
            >
              <IconCopy className="h-4 w-4" />
              <span className="sr-only">Copy project link</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>Copy project link</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
